<template>
    <TabsCard
        v-if="getLastAccountEventCount"
        class="tabs-card"
        :count="getLastAccountEventCount"
        cardTitle="Обучение"
        :isDataFull="isDataFull"
        :infoTitle="lastEvent.name"
        :emptyImgLink="emptyImgLink"
        emptyText="Нет активных курсов"
        :imgLink="imgLink"
        :infoDescription="lastEvent.description"
        :lmsLink="lastEvent.eventSiteUrl"
        :selectBtnLink="selectBtnLink"
        toFullRouter="/account/learn"
        toFullBtnText="Смотреть все"
        continueBtnText="Продолжить обучение"
    />
    <EmptyTabsCard
        v-else
        :emptyImgLink="emptyImgLink"
        cardTitle="Обучение"
        toFullRouter="/education"
        emptyText="Нет активных курсов"
    />
</template>

<script>
import TabsCard from '../../../UI/TabsCard.vue';
import { mapGetters, mapActions } from 'vuex';
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

const actions = ['loadAccountEvents'];

const getters = ['getLastAccountEvent', 'getLastAccountEventCount'];

export default {
    components: {
        EmptyTabsCard,
        TabsCard,
    },
    methods: {
        ...mapActions('accountTrack', actions),
    },
    computed: {
        emptyImgLink() {
            return require(`../../../../assets/images/oops-rhino-painter.svg`);
        },
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
        imgLink() {
            return this.lastEvent ? (this.lastEvent.cover ? this.lastEvent.cover.url : '') : '';
        },
        ...mapGetters('accountTrack', getters),
    },
    data() {
        return {
            lastEvent: {},
            isDataFull: false,
            selectBtnLink: '',
        };
    },
    async mounted() {
        await this.loadAccountEvents();
        this.lastEvent = this.getLastAccountEvent;
        this.isDataFull = Object.keys(this.lastEvent).length !== 0 || false;
        this.selectBtnLink = `/education`;
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
.tabs-card {
    margin-bottom: mrem(23);

    @include on-desktop {
        margin-bottom: rem(30);
    }
}
</style>
